
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import OptionsDialog from '../OptionsDialog/OptionsDialog'

// TODO: remove unused classes
import './BigButton.scss'

type Props = {
    to?: string,
    icon: string,
    text: string,
    title?: string,
    description?: string,
    meta?: string,
    footer?: string,
    status?: string,
    statusColor?: string,
    statusBg?: string,
    progress?: number,
    members?: number,
    tasks?: number,
    dueDate?: string,
    iconColor?: string,
    iconBg?: string,
    onClick?: any,
    onDisabledClick?: any,
    disabled?: boolean,
    altButtonClick?: any,
    altMenu?: any,
}

const BigButton = (props: Props) => {

    const history = useHistory()

    const [ showAltMenu, setShowAltMenu ] = useState(false)

    const handleClick = (e:any) => {
        e.preventDefault()

        if (props.disabled) {

            props.onDisabledClick && props.onDisabledClick()

            return
        }

        if (props.to) {

            history.push(props.to)
        } else {

            props.onClick()
        }
    }

    const handleAltClick = (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        props.altButtonClick()
    }

    const renderIcon = () => {
        if (props.icon.includes('fa-')) return <i className={props.icon}></i>

        return <span className={props.icon}></span>
    }

    const progress = Math.max(0, Math.min(100, props.progress ?? 0))

    return (
        <>
            <a href="#" data-testid="big-button" className={`big-button-link ${props.disabled ? 'is-disabled' : ''}`} onClick={(e) => handleClick(e)}>
                <div className={`big-button ${props.disabled ? 'is-disabled' : ''}`}>
                    {props.altButtonClick && (
                        <button data-testid="alt-button" className="alt-button"
                            onClick={(e) => handleAltClick(e)}
                        >
                            <i className="fas fa-f2 fa-times"></i>
                        </button>
                    )}
                    {props.altMenu && (
                        <button data-testid="alt-button" className="alt-button"
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()

                                setShowAltMenu(true)
                            }}
                        >
                            <i className="fas fa-fw fa-ellipsis-v"></i>
                        </button>
                    )}
                    <div className="big-button__top">
                        <div className="icon" style={{ backgroundColor: props.iconBg, color: props.iconColor }}>
                            {renderIcon()}
                        </div>
                    </div>
                    <div className="text">
                        {props.text}
                    </div>
                    {props.progress === undefined && props.title && <div className="big-button__title">{props.title}</div>}
                    {props.progress === undefined && props.description && <div className="big-button__description">{props.description}</div>}
                    {(props.status || props.members !== undefined || props.tasks !== undefined) && (
                        <div className="big-button__meta-row">
                            {props.status && (
                                <span className="big-button__status" style={{ backgroundColor: props.statusBg, color: props.statusColor }}>
                                    <i style={{ backgroundColor: props.statusColor }} />
                                    {props.status}
                                </span>
                            )}
                            {props.members !== undefined && <span className="big-button__metric"><i className="far fa-user" />{props.members}</span>}
                            {props.tasks !== undefined && <span className="big-button__metric"><i className="far fa-check-square" />{props.tasks}</span>}
                        </div>
                    )}
                    {props.progress !== undefined && (
                        <div className="big-button__progress">
                            <div className="big-button__progress-label">
                                <span>Avance</span>
                                <strong style={{ color: props.statusColor || props.iconColor }}>{progress}%</strong>
                            </div>
                            <div className="big-button__progress-track">
                                <span style={{ width: `${progress}%`, backgroundColor: props.statusColor || props.iconColor }} />
                            </div>
                        </div>
                    )}
                    {(props.dueDate || props.meta || props.footer) && (
                        <div className="big-button__footer">
                            {props.dueDate ? <span><i className="far fa-flag" /> Entrega {props.dueDate}</span> : (
                                <>{props.meta && <span>{props.meta}</span>}{props.footer && <strong>{props.footer}</strong>}</>
                            )}
                        </div>
                    )}
                </div>
            </a>

            {props.altMenu && (
                <OptionsDialog
                    show={showAltMenu}
                    title={props.text}
                    closeButton
                    onHide={() => setShowAltMenu(false)}
                    options={props.altMenu}
                />
            )}
        </>
    )
}

export default BigButton
